// https://github.com/CJY0208/react-router-cache-route
import React, { lazy } from "react";
import {
  Switch,
  Route,
  withRouter,
  Redirect
} from "react-router-dom";
import ResponsiveHelmet from "./responsive_helmet.js";
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'

import withCurrentUser from '../../hocs/with_current_user.js';
import { compose } from 'redux';

import ScrollToTop from "../../base/components/scroll_to_top.js";

import WebRoutes from "../../web/routes.js";
import AdminRoutes from "../../admin/routes.js";

import PageHeader from '../../web/layout/page_header';
import ShortPageHeader from '../../web/layout/page_header/short.jsx'
import PageFooter from '../../web/layout/page_footer.js';

import SignInPage from '../../web/pages/sessions/sign_in_page.js';
import SignUpPage from '../../web/pages/sessions/sign_up_page.js';
import RegistrationPage from '../../web/pages/sessions/registration_page.js';

import CompleteRegistrationPage from '../../web/pages/sessions/complete_registration_page.js';

import ForgotPasswordPage from '../../web/pages/sessions/forgot_password_page.js';
import ResetPasswordPage from '../../web/pages/sessions/reset_password_page.js';

import ProfileIndexPage from '../../web/pages/profile/profile_index_page.js';

import ProfilePersonalInfoPage from '../../web/pages/profile/profile_personal_info_page.js';
import ProfileQuestionnairePage from "../../web/pages/profile/profile_questionnaire_page.js";
import ProfilePaymentMethodPage from "../../web/pages/profile/profile_payment_method_page.js";

import ProfileIdentifyPage from '../../web/pages/profile/profile_identify_page.js';
import ProfileIdentificationSuccessPage from "../../web/pages/profile/profile_identification_success_page.js";

const ProjectPage = lazy(() => import('../../web/pages/project'));
const InvestPage = lazy(() => import('../../web/pages/invest'));

import DownloadablePage from '../../web/pages/downloadable';

import StaticPage from "../../web/pages/static_pages/static_page.js";

import NotFoundPage from "../../web/pages/static_pages/not_found_page.js";
import ThankYouPage from "../../web/pages/static_pages/thank_you_page.jsx";

const InvestmentPage = lazy(() => import("../../web/pages/investment"));
const ConfirmInvestmentPage = lazy(() => import("../../web/pages/confirm_investment"));

import XavinRedirectUseCase from "../../use_cases/sessions/xavin_redirect_use_case.js";

export const TopBarHeight = "4rem";

const bodyStyle = {
  position: "absolute",
  top: TopBarHeight,
  left: "0px",
  right: "0px",
}


class Web extends React.Component  {

  isLoggedIn = () => {
    const { currentUser } = this.props;
    return Boolean(currentUser)
  }

  isAdmin = () => {
    const {
      adminDashboardAbilityInfo: { use: allowAdmin = false } = {}
    } = this.props;
    return allowAdmin;
  }

  isIdentified = () => {
    const { currentUser } = this.props;
    return currentUser.identificationStatus === "identified";
  }

  redirectForLoggedIn = () => {
    return (
      <Redirect to = { WebRoutes.xavin() } />
    );
  }

  redirectForNotLoggedIn = () => {
    const { location } = this.props;
    return (
      <Redirect to = { {
        pathname: WebRoutes.signIn(),
        state: {
          from: location
        }
      } } />
    );
  }

  redirectForAdmin = () => {
    return (
      <Redirect to = { AdminRoutes.index() } />
    );
  }

  redirectForIdentified = () => {
    return (
      <Redirect to = { AdminRoutes.profile() } />
    );
  }

  behavior = (cached) => {
    if(cached) {
      return { style: { display: "none" } }
    }
    return undefined;
  }

  render() {
    return <React.Fragment>
      <ResponsiveHelmet allowedResponsive = { true } />
      { this.pageHeader() }
      <div style={bodyStyle}>
      <ScrollToTop />
      <CacheSwitch>
        <CacheRoute exact
                    sensitive
                    path = { WebRoutes.index() }
                    cacheKey = { WebRoutes.index() }
                    when = { "always" }
                    behavior = { this.behavior }
                    render = { ({ match }) => {
                      if(this.isAdmin()) {
                        return this.redirectForAdmin();
                      }
                      if(this.isLoggedIn()) {
                        return this.redirectForLoggedIn();
                      }
                      return this.redirectForNotLoggedIn();
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.signIn() }
               render = { ({ match }) => {
                if(this.isLoggedIn()) {
                  return this.redirectForLoggedIn();
                }
                return <React.Fragment>
                  <SignInPage key = { match.url }
                              match = { match } />
                </React.Fragment>
        }} />
        <Route exact
          sensitive
          path = { WebRoutes.xavin() }
          render = { () => {
            return XavinRedirectUseCase.execute()
            .then((result) => {
              const { url, key } = result;
              window.location.href = url + '?key=' + key
            })
            .catch((result) => {
              const { errorData } = result;
              this.setState({
                submit: false,
                errorData: errorData
              });
              this.props.showServerErrorIfNeed(result);
            })
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.signUp() }
               render = { ({ match }) => {
                 if(this.isLoggedIn()) {
                   return this.redirectForLoggedIn();
                 }
                 return <React.Fragment>
                   <SignUpPage key = { match.url }
                               match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.registration() }
               render = { ({ match }) => {
                 if(this.isLoggedIn()) {
                   return this.redirectForLoggedIn();
                  }
                  return <React.Fragment>
                    <RegistrationPage key = { match.url }
                                      match = { match } />
                  </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.completeRegistration() }
               render = { ({ match }) => {
                 return <React.Fragment>
                   <CompleteRegistrationPage key = { match.url }
                                             match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.forgotPassword() }
               render = { ({ match }) => {
                 if(this.isLoggedIn()) {
                   return this.redirectForLoggedIn();
                  }
                  return <React.Fragment>
                    <ForgotPasswordPage key = { match.url }
                                        match = { match } />
                  </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.resetPassword() }
               render = { ({ match }) => {
                 if(this.isLoggedIn()) {
                   return this.redirectForLoggedIn();
                 }
                 return <React.Fragment>
                    <ResetPasswordPage key = { match.url }
                                       match = { match } />
                  </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.profile() }
               render = { ({ match }) => {
                 if(this.isAdmin()) {
                   return this.redirectForAdmin()
                 }
                 if(!this.isLoggedIn()) {
                   return this.redirectForNotLoggedIn();
                 }
                 return <React.Fragment>
                   <ProfileIndexPage key = { match.url }
                                     match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.profilePersonalInfo() }
               render = { ({ match }) => {
                 if(this.isAdmin()) {
                   return this.redirectForAdmin()
                 }
                 if(!this.isLoggedIn()) {
                   return this.redirectForNotLoggedIn();
                 }
                 return <React.Fragment>
                   <ProfilePersonalInfoPage key = { match.url }
                                            match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.profileQuestionnaire() }
               render = { ({ match }) => {
                 if(this.isAdmin()) {
                   return this.redirectForAdmin();
                 }
                 if(!this.isLoggedIn()) {
                  return this.redirectForNotLoggedIn();
                 }
                 return <React.Fragment>
                   <ProfileQuestionnairePage key = { match.url }
                                             match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.profilePaymentMethod() }
               render = { ({ match }) => {
                 if(this.isAdmin()) {
                   return this.redirectForAdmin();
                 }
                 if(!this.isLoggedIn()) {
                  return this.redirectForNotLoggedIn();
                 }
                 return <React.Fragment>
                   <ProfilePaymentMethodPage key = { match.url }
                                           match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.profileIdentify() }
               render = { ({ match }) => {
                 if(this.isAdmin()) {
                   return this.redirectForAdmin();
                 }
                 if(!this.isLoggedIn()) {
                  return this.redirectForNotLoggedIn();
                 }
                 if(this.isIdentified()) {
                  return this.redirectForIdentified()
                 }
                 return <React.Fragment>
                   <ProfileIdentifyPage key = { match.url }
                                        match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.profileIdentificationSuccess() }
               render = { ({ match }) => {
                 if(this.isAdmin()) {
                   return this.redirectForAdmin();
                 }
                 if(!this.isLoggedIn()) {
                  return this.redirectForNotLoggedIn();
                 }
                 if(this.isIdentified()) {
                  return this.redirectForIdentified()
                 }
                 return <React.Fragment>
                   <ProfileIdentificationSuccessPage key = { match.url }
                                                     match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.confirm_investment() }
               render = { ({ match }) => {
                 const { params } = match;
                 if(this.isAdmin()) {
                   return this.redirectForAdmin();
                  }
                  if(!this.isLoggedIn()) {
                    return this.redirectForNotLoggedIn();
                  }
                  return <React.Fragment>
                    <ConfirmInvestmentPage key = { match.url }
                                    match = { match }
                                    identifier = { params.identifier } />
                  </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.investment() }
               render = { ({ match }) => {
                 const { params } = match;
                 if(this.isAdmin()) {
                   return this.redirectForAdmin();
                  }
                  if(!this.isLoggedIn()) {
                    return this.redirectForNotLoggedIn();
                  }
                  return <React.Fragment>
                    <InvestmentPage key = { match.url }
                                    match = { match }
                                    identifier = { params.identifier } />
                  </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.project() }
               render = { ({ match }) => {
                 const { params } = match;
                 return <React.Fragment>
                   <ProjectPage key = { match.url }
                                match = { match }
                                slug = { params.identifier } />
                 </React.Fragment>
        }} />
        <Route
               exact
               sensitive
               path = { WebRoutes.invest() }
               render = { ({ match }) => {
                if(this.isAdmin()) {
                  return this.redirectForAdmin()
                }
                if(!this.isLoggedIn()) {
                  return this.redirectForNotLoggedIn();
                }
                 const { params } = match;
                 return <InvestPage key = { match.url }
                          match = { match }
                          slug = { params.identifier } />
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.downloadable() }
               render = { ({ match }) => {
                 const { params } = match;
                 return <DownloadablePage key = { match.url }
                          match = { match }
                          slug = { params.identifier } />
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.pageNotFound() }
               render = { ({ match }) => {
                 return <React.Fragment>
                   <NotFoundPage key = { match.url }
                                 match = { match } />
                 </React.Fragment>
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.thankYouPage() }
               render = { ({ match }) => {
                 return <ThankYouPage key = { match.url } match = { match } />
        }} />
        <Route exact
               sensitive
               path = { WebRoutes.page() }
               render = { ({ match }) => {
                 const { params } = match;
                 return <StaticPage key = { match.url }
                               match = { match }
                               identifier = { params.identifier } />
        }} />
        <Route render = { ({ match }) => {
                return <React.Fragment>
                  <NotFoundPage key = { match.url }
                                match = { match } />
                </React.Fragment>
        }} />
      </CacheSwitch>
      <PageFooter />
      {/*{ this.pageFooter() }*/}
      </div>
      {/* <ModalContainer /> */}
    </React.Fragment>
  }

  pageHeader() {
    return this.withoutColonTitles(
      <PageHeader />,
      <ShortPageHeader />
    )
  }

  pageFooter() {
    return this.withoutColonTitles(
      <PageFooter />,
      <React.Fragment />
    )
  }

  withoutColonTitles(component, alternative) {
    return <Switch>
      <Route exact
            sensitive
            path = { WebRoutes.signIn()}
            render = { () => {
              return alternative
      }} />
      <Route exact
            sensitive
            path = { WebRoutes.xavin()}
            render = { () => {
              return alternative
      }} />
      <Route exact
             sensitive
             path = { WebRoutes.signUp() }
             render = { () => {
               return alternative
      }} />
      <Route exact
             sensitive
             path = { WebRoutes.registration()}
             render = { () => {
               return alternative
      }} />
      <Route exact
             sensitive
             path = { WebRoutes.completeRegistration()}
             render = { () => {
               return alternative
      }} />
      <Route exact
             sensitive
             path = { WebRoutes.forgotPassword() }
             render = { () => {
               return alternative
      }} />
      <Route exact
             sensitive
             path = { WebRoutes.resetPassword() }
             render = { () => {
               return alternative
      }} />
      <Route render = { () => {
        return component
      }} />
    </Switch>
  }

}
export default compose(withRouter, withCurrentUser)(Web);
